export interface CapitalFlowInput {
  initialCapital: number;
  depositsUSD: number;
  withdrawalsUSD: number;
  totalCapitalUSD: number;
  manualPremiums?: number;
}

export interface CapitalFlowBreakdown {
  capitalBasis: number;
  capitalChange: number;
  extraBonusYield: number;
  netCapitalChange: number;
}

const safeNumber = (value: number | null | undefined): number =>
  Number.isFinite(value) ? Number(value) : 0;

export const getCapitalFlowBreakdown = (
  stats: CapitalFlowInput,
): CapitalFlowBreakdown => {
  const capitalBasis =
    safeNumber(stats.initialCapital) +
    safeNumber(stats.depositsUSD) -
    safeNumber(stats.withdrawalsUSD);
  const capitalChange = safeNumber(stats.totalCapitalUSD) - capitalBasis;
  const extraBonusYield = safeNumber(stats.manualPremiums);

  return {
    capitalBasis,
    capitalChange,
    extraBonusYield,
    netCapitalChange: capitalChange + extraBonusYield,
  };
};
